export default function pecepModalChamada() {
  const header = document.querySelector("#header");
  header.style.display = "none";
  console.log("coming-soon", header);
}
